'use es6';

import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
function NopeZone({
  top,
  left,
  right,
  bottom
}) {
  return /*#__PURE__*/_jsx("div", {
    className: "hs-non-ls-nope-zone",
    style: {
      left,
      width: right - left,
      top,
      height: bottom - top
    }
  });
}
NopeZone.propTypes = {
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  right: PropTypes.number.isRequired,
  bottom: PropTypes.number.isRequired
};
export default NopeZone;